export const referralJobOpeningsStoreKey = 'referralJobOpenings';
